$.fn.usersPage = function () {
  function isInUsersPage() {
    return $("#usersPage").length > 0;
  }

  if (isInUsersPage()) {
    var $rowsNo;
    $(document).ready(function () {
      $rowsNo = $("#accessGroupTable tbody tr").filter(function () {
        var data = $(this);
        return data;
      });
      if ($("#isStatistics").is(":checked")) {
        var $rowData = $rowsNo;
        $rowData
          .filter(function () {
            var data = $(this).find("td").eq(1).text();
            return (
              $.trim(data) === "NONE" ||
              $.trim(data) === "GRANTS" ||
              $.trim(data) === "OTHER"
            );
          })
          .hide();
        $rowData
          .filter(function () {
            var data = $(this).find("td").eq(1).text();
            return $.trim(data) === "STATISTICS";
          })
          .show();
      }
    });
    //        var $rowsNo = $('#accessGroupTable tbody tr').filter(function () {
    //            var data = $(this);
    //            return data;
    //        });
    var statsCount = 0;
    var grantsCount = 0;
    var otherCount = 0;

    $("#isStatistics").click(function () {
      if (statsCount > 0) {
        $(this).removeClass("selected");
        $("#statsLabel").removeClass("selected");
        statsCount = 0;
        var $rowData = $rowsNo;
        $rowData
          .filter(function () {
            var data = $(this).find("td").eq(1).text();
            return (
              $.trim(data) === "STATISTICS" ||
              $.trim(data) === "NONE" ||
              $.trim(data) === "GRANTS" ||
              $.trim(data) === "OTHER"
            );
          })
          .show();
      } else {
        var $rowData = $rowsNo;
        $rowData
          .filter(function () {
            var data = $(this).find("td").eq(1).text();
            return (
              $.trim(data) === "NONE" ||
              $.trim(data) === "GRANTS" ||
              $.trim(data) === "OTHER"
            );
          })
          .hide();
        $rowData
          .filter(function () {
            var data = $(this).find("td").eq(1).text();
            return $.trim(data) === "STATISTICS";
          })
          .show();
        statsCount++;
      }
      grantsCount = 0;
      otherCount = 0;
    });
    $("#isGrants").click(function () {
      if (grantsCount > 0) {
        $("#grantsLabel").removeClass("selected");
        grantsCount = 0;
        var $rowData = $rowsNo;
        $rowData
          .filter(function () {
            var data = $(this).find("td").eq(1).text();
            return (
              $.trim(data) === "STATISTICS" ||
              $.trim(data) === "NONE" ||
              $.trim(data) === "GRANTS" ||
              $.trim(data) === "OTHER"
            );
          })
          .show();
      } else {
        var $rowData = $rowsNo;
        $rowData
          .filter(function () {
            var data = $(this).find("td").eq(1).text();
            return (
              $.trim(data) === "NONE" ||
              $.trim(data) === "STATISTICS" ||
              $.trim(data) === "OTHER"
            );
          })
          .hide();
        $rowData
          .filter(function () {
            var data = $(this).find("td").eq(1).text();
            return $.trim(data) === "GRANTS";
          })
          .show();
        grantsCount++;
      }
      statsCount = 0;
      otherCount = 0;
    });

    $("#isOther").click(function () {
      if (otherCount > 0) {
        var $rowData = $rowsNo;
        $("#otherLabel").removeClass("selected");
        otherCount = 0;
        $rowData
          .filter(function () {
            var data = $(this).find("td").eq(1).text();
            return (
              $.trim(data) === "STATISTICS" ||
              $.trim(data) === "NONE" ||
              $.trim(data) === "GRANTS" ||
              $.trim(data) === "OTHER"
            );
          })
          .show();
      } else {
        var $rowData = $rowsNo;
        $rowData
          .filter(function () {
            var data = $(this).find("td").eq(1).text();
            return $.trim(data) === "GRANTS" || $.trim(data) === "STATISTICS";
          })
          .hide();
        $rowData
          .filter(function () {
            var data = $(this).find("td").eq(1).text();
            return $.trim(data) === "NONE" || $.trim(data) === "OTHER";
          })
          .show();
        otherCount++;
      }
      statsCount = 0;
      grantsCount = 0;
    });

    $("#userEmail").on("change", function () {
      $("#errorMessage").text("");
      $("#message").text("");
      if ($("#userEmail").val() != "") {
        ajaxMethod($("#userEmail").val());
      }

      //            displayError("sample message");
    });
  }

  function ajaxMethod(email) {
    $.ajax({
      dataType: "JSON",
      url: "/admin/users/validate?email=" + email,
    })
      .done(function (response) {
        if (response[0].key != "Proceed") {
          var redirectLink = "go to edit page.";
          var editLink = redirectLink.link(
            "/admin/users/user-details?userId=" + response[0].adUserId,
          );
          var message = response[0].key + editLink;
          document.getElementById("errorMessage").innerHTML = message;
          $("#message").text("");
          //                        displayError(message);
        } else {
          displayError("");
          $("#message").text("Proceed with current name");
        }
      })
      .fail(function (response) {
        //                     displayError(response);
      });
  }

  function displayError(errorMessage) {
    $("#errorMessage").text(errorMessage);
  }
};
